import { render, staticRenderFns } from "./roles.pug?vue&type=template&id=cbe5bd74&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./roles.scss?vue&type=style&index=0&id=cbe5bd74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe5bd74",
  null
  
)

export default component.exports